import React, { useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';
import { ChipsSelectProps, ChipsSelect } from '../../ChipsSelect/ChipsSelect';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

type AppFormChipsSelectProps<MULTI extends boolean = false, VALUE = string> = Partial<
  ChipsSelectProps<MULTI, VALUE>
> & {
  name?: string;
};

export const AppFormChipsSelect = <MULTI extends boolean = false, VALUE extends unknown = string>(
  props: AppFormChipsSelectProps<MULTI, VALUE>
) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const name = 'name' in props ? props.name : context.name;
  const value = 'value' in props ? props.value : name ? getIn(values, name) : undefined;
  const multiple = 'multiple' in props;
  const onSelect = props.onSelect;

  const handleOnSelectChange = useCallback(
    (value: any) => {
      if (onSelect) {
        onSelect(value);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, value);
      }
    },
    [setFieldTouched, setFieldValue, name, onSelect]
  );
  return (
    <ChipsSelect
      {...props}
      options={props.options ?? []}
      value={value ?? (multiple ? EMPTY : undefined)}
      required={false}
      onSelect={handleOnSelectChange}
      id={(props.id ?? context.name) ? `${context.name}-input` : undefined}
      dataTest={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
    />
  );
};

const EMPTY: any[] = [];
